// client/src/coms/views/chatview_parts/chatUtils.js

export function safeObj(v) {
  return v && typeof v === 'object' ? v : {};
}

export function safeArr(v) {
  return Array.isArray(v) ? v : [];
}

export function toInt(v, fallback = null) {
  const n = Number(v);
  return Number.isFinite(n) ? Math.floor(n) : fallback;
}

export function normalizeNameForCompare(v) {
  const s = String(v == null ? '' : v).trim();
  return s.toLowerCase();
}

export function extractNumericId(v) {
  if (v == null) return null;
  const s = String(v).trim();
  if (!s) return null;
  if (/^\d+$/.test(s)) return s;
  const m = s.match(/(\d+)\s*$/);
  return m && m[1] ? m[1] : null;
}

export async function apiFetchJson(url, opts) {
  const res = await fetch(url, {
    credentials: 'include',
    ...opts,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(opts && opts.headers ? opts.headers : {}),
    },
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const msg = (data && (data.error || data.detail || data.message)) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    err.url = url;
    throw err;
  }

  return data;
}

export function parseDate(ts) {
  if (!ts) return null;
  try {
    const d = new Date(ts);
    if (!Number.isNaN(d.getTime())) return d;
  } catch {}
  return null;
}

export function pad2(n) {
  return String(n).padStart(2, '0');
}

export function isSameLocalDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function formatTimeOnly(d) {
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function formatDateTime(d) {
  const yyyy = d.getFullYear();
  const mm = pad2(d.getMonth() + 1);
  const dd = pad2(d.getDate());
  return `${dd}/${mm}/${yyyy} ${formatTimeOnly(d)}`;
}

export function formatStamp(createdAt) {
  const d = parseDate(createdAt);
  if (!d) return '';
  const now = new Date();
  if (isSameLocalDay(d, now)) return formatTimeOnly(d);
  return formatDateTime(d);
}

export function normalizeUser(u) {
  if (!u) return null;
  if (u.user && typeof u.user === 'object') return u.user;
  if (u.me && typeof u.me === 'object') return u.me;
  if (u.data && typeof u.data === 'object') return u.data;
  return u;
}

export function getUserId(u) {
  const me = normalizeUser(u);
  if (!me) return null;
  if (me.id != null) return toInt(me.id, null);
  if (me.user_id != null) return toInt(me.user_id, null);
  if (me.uid != null) return toInt(me.uid, null);
  return null;
}

export function getUserLabel(u) {
  const me = normalizeUser(u);
  if (!me) return '';
  return String(me.username || me.name || me.display_name || '').trim();
}

export function buildMembersNameMap(members) {
  const map = {};
  for (const m of safeArr(members)) {
    const o = safeObj(m);
    const id = o.id != null ? toInt(o.id, null) : o.user_id != null ? toInt(o.user_id, null) : null;
    if (!id) continue;
    const name = String(o.name || o.username || o.display_name || '').trim();
    if (!name) continue;
    map[id] = name;
  }
  return map;
}

export function avatarUrlForUserId(userId) {
  const id = toInt(userId, null);
  if (!id) return '';
  return `/uploads/voiceservers/users/${id}/avatar.webp`;
}

export function getMsFromCreatedAt(createdAt) {
  const d = parseDate(createdAt);
  return d ? d.getTime() : null;
}